import { IconFilter } from "@tabler/icons-react";

import { Badge, Button, type ButtonProps } from "~/ui";

export type FiltersButtonProps = Omit<ButtonProps, "leftIcon" | "variant"> & {
  nFiltersApplied: number;
};

export const FiltersButton = ({ children = "Filters", nFiltersApplied, ...props }: FiltersButtonProps) => {
  const leftIcon = nFiltersApplied === 0 ? <IconFilter size={16} /> : <Badge>{nFiltersApplied}</Badge>;
  return (
    <Button leftIcon={leftIcon} {...props} variant="outline">
      {children}
    </Button>
  );
};
